<div class="div-flex-column">
	@if (showLoading) {
		<div class="div-flex-column">
			<mat-icon class="success-checkmark align-center margin-top" svgIcon="sl-spinner"></mat-icon>
			<h2 class="row-center title registration-title" i18n="@@registerUser-registerUserConfirmationTitleLoading">
				Completing Registration...
			</h2>
		</div>
	}

	@if (showSuccess) {
		<div class="div-flex-column">
			<mat-icon class="success-checkmark align-center margin-top">check</mat-icon>
			<h2 class="row-center title" i18n="@@registerUser-registerUserConfirmationTitleSuccess">Registration Complete</h2>
			<p class="font-14 content-subtitle center" i18n="@@registerUser-registerUserConfirmationMessageSuccess">
				You have successfully completed your account registration.
			</p>
			<br />
			<button
				mat-button
				class="primary-button align-center web-button"
				style="min-width: unset"
				(click)="onSignInClicked()"
				data-automation-id="register-user-sign-in-button"
				i18n="@@registerUser-signIn"
			>
				Sign In
			</button>
			<a
				class="align-center mobile-button"
				(click)="openAppOrStore()"
				style="min-width: unset"
				data-automation-id="register-user-sign-in-mobile-button"
				i18n="@@registerUser-signInMobile"
			>
				Sign In to Mobile App
			</a>
		</div>
	}

	@if (showFailure) {
		<div class="div-flex-column">
			<mat-icon class="failure-crossout align-center margin-top">close</mat-icon>
			<h2 class="row-center title" i18n="@@registerUser-registerUserConfirmationTitleFailure">Registration Error</h2>
			<p class="font-14 content-subtitle center" i18n="@@registerUser-registerUserConfirmationMessageFailure">
				An error has occurred, please try again.
			</p>
			<br />
			<button
				mat-button
				class="primary-button align-center"
				style="min-width: unset"
				i18n="@@registerUser-tryAgain"
				data-automation-id="register-user-try-again-button"
				(click)="onRetryClicked()"
			>
				Try Again
			</button>
		</div>
	}
</div>
